




























































































































import { Component, Vue, PropSync, Watch } from "vue-property-decorator";
import { tiposEnderecoList } from "@/models/commons/EnderecoModel";
import { estadosList, EstadoModel } from "@/models/commons/EstadoModel";
import { EnderecoModel } from "@/models/commons/EnderecoModel";
import { cadastroPrestadorService } from "@/service/cadastro/saude/CadastroPrestadorService";
import { CidadeModel } from "@/models/commons/CidadeModel";
import { BairroModel } from "@/models/cadastros/saude/BairroModel";
import { mapasService } from "@/service/MapasService";

@Component
export default class Endereco extends Vue {
  tiposEndereco = tiposEnderecoList;
  estados = estadosList;
  cidades: CidadeModel[] = [];
  bairros: BairroModel[] = [];

  @PropSync("endereco", { required: true })
  enderecoSynced!: EnderecoModel;

  mounted(){
    this.obterCidades();
  }

  // @Watch("enderecoSynced.cep")
  // consultarEndereco(val?: string) {
  //   val = val?.replace(/\D/g, '');
  //   if (!!val && val.length == 8) {
  //     mapasService.obterEnderecoPorCep(val)
  //       .then((end) => {
  //         this.enderecoSynced.logradouro = end.logradouro;
  //         this.enderecoSynced.estado = end.estado;
  //         this.enderecoSynced.cidade = end.cidade;
  //         this.enderecoSynced.cidadeModel = this.cidades.find(c => c.nome == end.cidade);
  //         this.enderecoSynced.bairro = end.bairro;
  //         console.log(end, this.enderecoSynced);
  //       });
  //   }
  // }

  @Watch("enderecoSynced.estado")
  alterarEstado(val?: EstadoModel) {
    if (val && val.sigla) {
      this.obterCidades();
    }
  }

  @Watch("enderecoSynced.cidadeModel")
  alterarCidade(val?: CidadeModel) {
    if (!!val && !!val.nome) {
      this.obterBairros();
    }
  }

  obterCidades() {
    if (this.enderecoSynced.estado) {
      cadastroPrestadorService
        .obterCidades(this.enderecoSynced.estado.sigla)
        .then((cidades) => {
          this.cidades = cidades;
          if (this.enderecoSynced.cidadeModel && this.enderecoSynced.cidadeModel.id) {
            const cidade = this.cidades.find(c => c.id == this.enderecoSynced.cidadeModel?.id);
            if (cidade) {
              this.enderecoSynced.cidadeModel = cidade;
              this.obterBairros();
            }
          }
        });
    }
  }

  obterBairros() {
    if (this.enderecoSynced.cidadeModel?.nome) {
      cadastroPrestadorService.obterBairros(this.enderecoSynced.cidadeModel.nome)
        .then((bairros) => {
          this.bairros = bairros;
        });
    }
  }
}
